module.exports = __webpack_public_path__ + "fonts/TT_Commons_Pro_700_ExtraBold.e0e279c.woff";